
let routes = function (orgId, config, navItems) {
    let x =    [
        {
            path: ``,
            name: "",
            icon: "",
            layout: "",
        }
    ]
    if (navItems !== null) {
        x = navItems;
    }
    return x;
};

export default routes;
